import React, { useState, useRef, useContext } from 'react'

import { SnackBarContext } from 'Components/SnackBar'
import PreviewModal from './components/PreviewModal'
import {
  StyledWrapper,
  StyledTitle,
  StyledInfo,
  StyledTextArea,
  StyledWordsCount,
  StyledButtonsWrapper,
  StyledPreviewAdditionalInfoButton,
  StyledSaveAdditionalInfoButton,
} from './styles'
import { getAdditionalInfo, updateVideoOnboarding } from './gql'
import { useEffect } from 'react'

const WORDS_MAX_COUNT = 300

const AdditionalInfo = ({ cityId }) => {
  const [additionalInfo, setAdditionalInfo] = useState('')
  const [modalShow, setModalShow] = useState(false)
  const wordsCountRef = useRef(0)
  const runSnackBar = useContext(SnackBarContext)

  const getInfo = async () => {
    try {
      const req = await getAdditionalInfo({ id: cityId })
      const res = await req.json()

      const {
        data: {
          city: { videoOnboardingCityAdditionalInfo },
        },
      } = res
      if (videoOnboardingCityAdditionalInfo) {
        setAdditionalInfo(videoOnboardingCityAdditionalInfo)

        const count = videoOnboardingCityAdditionalInfo
          .split(/[\s]+/)
          .filter(element => element !== '').length
        if (count <= WORDS_MAX_COUNT) {
          wordsCountRef.current = count
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
    }
  }

  useEffect(() => {
    getInfo()
  }, [])

  const handleOpenModal = () => {
    setModalShow(true)
  }

  const handleCloseModal = () => {
    setModalShow(false)
  }

  const handleChange = e => {
    const count = e.target.value
      .split(/[\s]+/)
      .filter(element => element !== '').length
    if (count <= WORDS_MAX_COUNT) {
      wordsCountRef.current = count
      setAdditionalInfo(e.target.value)
    }
  }

  const handleSaveAdditionalInfo = async () => {
    await updateVideoOnboarding({ cityId, additionalInfo })
    runSnackBar({
      type: 'success',
      vertical: 'top',
      msg: 'Save success!',
    })
  }

  return (
    <StyledWrapper>
      <StyledTitle>Additional info and updates</StyledTitle>
      <StyledInfo>
        Please add country specific information and updates that can’t be
        covered in onboarding videos.
      </StyledInfo>
      <StyledTextArea
        value={additionalInfo}
        placeholder="Please don’t exceed 300 words"
        areaHeight="200px"
        onChange={handleChange}
      />
      <StyledWordsCount isReached={wordsCountRef.current === WORDS_MAX_COUNT}>
        {wordsCountRef.current} words of {WORDS_MAX_COUNT}
      </StyledWordsCount>
      <StyledButtonsWrapper>
        <StyledPreviewAdditionalInfoButton onClick={handleOpenModal}>
          Preview
        </StyledPreviewAdditionalInfoButton>
        <StyledSaveAdditionalInfoButton onClick={handleSaveAdditionalInfo}>
          Save
        </StyledSaveAdditionalInfoButton>
      </StyledButtonsWrapper>
      <PreviewModal
        modalShow={modalShow}
        additionalInfo={additionalInfo}
        onCloseModal={handleCloseModal}
      />
    </StyledWrapper>
  )
}

export default AdditionalInfo
